// extracted by mini-css-extract-plugin
export default {"trainingAttachmentViewer":"styles_trainingAttachmentViewer__Lrp5N","main":"styles_main__1CTR2","docViewer":"styles_docViewer__fsInX","vidViewer":"styles_vidViewer__x+Mqv"};